import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Modules / Mixins
import isResizable from '../../../../mixins/resizable';

// Related Components
import LogoutLogo from '../../../agents/subscribe/logout_logo';

class ConfirmCall extends React.Component {
  static propTypes = {
    isDesktop: PropTypes.bool,
  };

  render() {
    const { isDesktop } = this.props;

    return (
      <div className='width-100pct'>
        <div className='height-60 margin-bottom-45'>
          <LogoutLogo />
        </div>
        <div id='confirm_call' className='margin-center'>
          <div className='width-100pct flex justify-center'>
            <div className={classNames('margin-auto min-height-465 margin-bottom-80', {
              'flex': isDesktop,
            })}>
              <div className='width-440'>
                <div className='heading margin-bottom-25'>
                  <span className='thankyou margin-right-5'>Thank you!</span>
                  Our team will be contacting you soon
                </div>
                <div className='sub-heading'>
                  We're excited to connect and chat with<br />
                  you! Our team will be reaching out<br />
                  shortly to schedule a demo.
                </div>
              </div>
              <div>
                <img src={`${gon.HUBSPOT_ASSETS_URL}/oomple/assets/app/v5/sign_up/confirm_call.png`} width='90%' />
              </div>
            </div>
          </div>
          <div className='footer-header margin-bottom-50 flex justify-center'>Specialized Consultants in Top Technologies</div>
          <div className='width-100pct flex justify-center'>
            <img src={`${gon.HUBSPOT_ASSETS_URL}/oomple/assets/app/v5/sign_up/companies.png`} />
          </div>
        </div>
      </div>
    )
  }
}

export default isResizable(ConfirmCall);